import { render, staticRenderFns } from "./MatchOrder.vue?vue&type=template&id=a5e8185c&"
import script from "./MatchOrder.vue?vue&type=script&lang=js&"
export * from "./MatchOrder.vue?vue&type=script&lang=js&"
import style0 from "./MatchOrder.vue?vue&type=style&index=0&rel=stylesheet%2Fless&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports